// extracted by mini-css-extract-plugin
export default {"soldOutContainer":"_2aE_H"};